import { IS_LOCAL_ENV } from "../App";
import { _axios } from "./config";
import qs from "qs";

//en sort se puede empezar con '-' para ordenar inversamente

//traer lista de temporadas
export const getSeasons = async () => { //evaluar en otros componentes
  try {
    const { data } = await _axios.get("/api/seasons?sort=-endDate&depth=1");
    return data;
  }
  catch (err) {
    IS_LOCAL_ENV && console.error(err);
    throw err;
  }
}

export const getSeasonsWithoutLimit = async () => { //evaluar en otros componentes
  try {
    const { data } = await _axios.get("/api/seasons?sort=-endDate&depth=0&limit=0");
    return data;
  }
  catch (err) {
    IS_LOCAL_ENV && console.error(err);
    throw err;
  }
}

export const getSeasonsByPage = async (page) => {
  try {
    const { data } = await _axios.get(`/api/seasons?sort=-endDate&depth=1&page=${page}`);
    return data;
  }
  catch (err) {
    IS_LOCAL_ENV && console.error(err);
    throw err;
  }
}

//traer bloques de una temporada buscando por id de temporada
export const getSeasonBlocksById = async (seasonId) => {

  const query = { //defnir query para usar en la url de la api
    season: {
      equals: seasonId,
    }
  }

  const stringifiedQuery = qs.stringify(
    {
      where: query,
    },
    { addQueryPrefix: true } //creo que es para añadir "?"
  )

  try {
    const { data } = await _axios.get(`/api/blocks${stringifiedQuery}&depth=1`);
    return data.docs;
  } catch (err) {
    IS_LOCAL_ENV && console.error(err);
    throw err;
  }
}

//traer bloques de una temporada buscando por número de temporada(valor único)
export const getSeasonBlocksBySeasonNumber = async (seasonNumber) => {

  const query = { //defnir query para usar en la url de la api
    number: {
      equals: seasonNumber,
    }
  }

  const stringifiedQuery = qs.stringify(
    {
      where: query,
    },
    { addQueryPrefix: true } //creo que es para añadir "?"
  )

  try {
    const { data } = await _axios.get(`/api/seasons${stringifiedQuery}&depth=2`);
    return data.docs[0].blocks; //retorna arreglo de bloques de la temporada
  } catch (err) {
    IS_LOCAL_ENV && console.error(err);
    throw err;
  }
}

//actualizar lista de medicinas de un bloque
export const updateBlockSupplies = async (blockId, newSupplies) => {
  try {
    const res = await _axios.patch(`api/blocks/${blockId}`, { supplies: newSupplies });
    IS_LOCAL_ENV && console.log(res.status);
    return res.data;
  }
  catch (err) {
    IS_LOCAL_ENV && console.error(err);
    throw err;
  }
}

export const updateBlock = async (blockId, updatedProps) => { //updated props solo contiene props editables
  try {
    const res = await _axios.patch(`api/blocks/${blockId}`, { ...updatedProps });
    IS_LOCAL_ENV && console.log(res.status);
    return res.data;
  }
  catch (err) {
    IS_LOCAL_ENV && console.error(err);
    throw err;
  }
}

export const createSeasonBlock = async (props) => { //subir un registro de laboratorio
  //se necesita previamente la info de ambientes disponibles
  try {
    const { data } = await _axios.post("/api/blocks", { ...props });
    return data.doc;
  } catch (err) {
    IS_LOCAL_ENV && console.error(err);
    throw err;
  }
}

export const relateBlockToSeason = async (seasonId, prevBlockIds, newBlockId) => {
  try {
    const response = await _axios.patch(`api/seasons/${seasonId}`, { blocks: newBlockId ? [...prevBlockIds, newBlockId] : prevBlockIds });
    IS_LOCAL_ENV && console.log(response.status);
    return response.data;
  }
  catch (err) {
    IS_LOCAL_ENV && console.error(err);
  }
}

export const createSeason = async (props) => { //subir un registro de laboratorio
  //se necesita previamente la info de ambientes disponibles
  try {
    const { data } = await _axios.post("/api/seasons", { ...props });
    return data.doc;
  } catch (err) {
    IS_LOCAL_ENV && console.error(err);
    throw err;
  }
}

const createDefaltBlocks = async (seasonId, tempInitDate, tempEndDate) => {
  //letras de los 4 bloques
  const blockLetters = ['A', 'B', 'C', 'D'];

  try {
    const createPromises = blockLetters.map((bl) => { //crea funciones pendientes a ejecutar, que son los posts
      let props = {
        name: `Bloque ${bl}`,
        letter: bl,
        season: seasonId,
        initDate: tempInitDate,
        endDate: tempEndDate,
        supplies: [],
      };
      return createSeasonBlock(props);
    })

    const responses = await Promise.all(createPromises); //resuelce las promesas
    IS_LOCAL_ENV && console.log(responses);
    return responses;//retorna array de nuevos bloques
  } catch (err) {
    IS_LOCAL_ENV && console.error(err);
    throw err;
  }
}

export const createDefaultBlocksAndRelateToSeason = async (seasonId, tempInitDate, tempEndDate) => {
  try {
    // Crear los bloques
    const nuevosBloques = await createDefaltBlocks(seasonId, tempInitDate, tempEndDate);

    // Obtener los IDs de los nuevos bloques
    const nuevosBlockIds = nuevosBloques.map(block => block.id);

    // Relacionar cada bloque con la temporada
    const res = await relateBlockToSeason(seasonId, nuevosBlockIds);
    IS_LOCAL_ENV && console.log(res);

    return nuevosBloques; // Retorna los bloques creados y relacionados
  } catch (err) {
    IS_LOCAL_ENV && console.error(err);
    throw err;
  }
};

export const getSeasonByNumber = async (number, depth) => {
  const query = { //defnir query para usar en la url de la api
    number: {
      equals: number,
    }
  }

  const stringifiedQuery = qs.stringify(
    {
      where: query,
    },
    { addQueryPrefix: true } //creo que es para añadir "?"
  )
  try {//solo será 4 bloques por temporada, no requiere paginación
    const { data } = await _axios.get(`/api/seasons${stringifiedQuery}&depth=${depth ? depth : "1"}&limit=0`);
    return data.docs;
  }
  catch (err) {
    IS_LOCAL_ENV && console.error(err);
    throw err;
  }
}

export const getSeasonByNumberFiltered = async (number, depth) => {

  const query = {
    number: {
      equals: number,
    }
  }

  // IS_LOCAL_ENV && console.log("queryObj creado: ", query);

  const stringifiedQuery = qs.stringify(
    {
      where: query,
    },
    { addQueryPrefix: true }
  )
  try {//solo será 4 bloques por temporada, no requiere paginación
    const { data } = await _axios.get(`/api/seasons${stringifiedQuery}&depth=${depth ? depth : "1"}&limit=0`);
    IS_LOCAL_ENV && console.log("data traida: ", data.docs)
    return data.docs;
  }
  catch (err) {
    IS_LOCAL_ENV && console.error(err);
    throw err;
  }

}

export const updateSeasonFD = async (seasonId, newEndDate) => {
  try {
    const { data } = await _axios.patch(`/api/seasons/${seasonId}`, { endDate: newEndDate });
    IS_LOCAL_ENV && console.log(data);
  }
  catch (err) {
    IS_LOCAL_ENV && console.error(err);
    throw err;
  }
}

export const updateSeasonStatus = async (seasonId, newStatus) => {
  try {
    const response = await _axios.patch(`/api/seasons/${seasonId}`, { status: newStatus });
    IS_LOCAL_ENV && console.log(response);
  }
  catch (err) {
    IS_LOCAL_ENV && console.error(err);
    throw err;
  }
}

//blockSDates = block scheduled dates
//objs = arreglo de objetos, donde cada ojeto tiene las props de un bloque, y las fechas que tiene que crear

// export const createBlockSDates = async (objs) => { //pendiente
//   try {
//     for (const obj of objs) {
//       let objBsdsIds = [];

//       for (const date of obj.datesToCreate) {
//         const bsdProps = {
//           date,
//           block: obj.blockInfo.id,
//           comsumptions: obj.blockInfo.supplies.map((supplie) => ({
//             supplie: supplie.id,
//             quantity: 50,
//           })),
//         };

//         const { data } = await _axios.post(`/api/blockSDates?depth=0`, bsdProps);
//         IS_LOCAL_ENV && console.log("dat", data);
//         objBsdsIds.push(data.doc.id);
//       }

//       await _axios.patch(`/api/blocks/${obj.blockInfo.id}`, { blockSDates: objBsdsIds });
//     }

//     await updateSeasonStatus(objs[0].blockInfo.season.id, "pending");
//     IS_LOCAL_ENV && console.log("Fechas programadas y relaciones de bloques creadas exitosamente.");
//   } catch (err) {
//     IS_LOCAL_ENV && console.error("Error al crear fechas programadas:", err);
//     throw err;
//   }
// };


//same func with promise all
export const createBlockSDates = async (objs) => {
  try {
    for (const obj of objs) {
      let objBsdsIds = [];

      // Ejecutamos las solicitudes en paralelo con Promise.all()
      const postPromises = obj.datesToCreate.map(async (date) => {
        try {
          const bsdProps = {
            date,
            block: obj.blockInfo.id,
            comsumptions: obj.blockInfo.supplies.map((supplie) => ({
              supplie: supplie.id,
              quantity: 50,
            })),
          };

          const { data } = await _axios.post(`/api/blockSDates?depth=0`, bsdProps);
          IS_LOCAL_ENV && console.log("dat", data);
          objBsdsIds.push(data.doc.id);
        } catch (error) {
          IS_LOCAL_ENV && console.error("Error al crear fecha:", error);
          throw error; // Lanzamos el error para detener la ejecución
        }
      });

      await Promise.all(postPromises); // Esperamos a que se completen todas las fechas

      // Ahora actualizamos el bloque
      await _axios.patch(`/api/blocks/${obj.blockInfo.id}`, { blockSDates: objBsdsIds });
    }

    // Si todo sale bien, actualizamos el estado de la temporada
    await updateSeasonStatus(objs[0].blockInfo.season.id, "pending");

    IS_LOCAL_ENV &&
      console.log("Fechas programadas y relaciones de bloques creadas exitosamente.");
  } catch (err) {
    IS_LOCAL_ENV && console.error("Error al crear fechas programadas:", err);
    throw err; // Importante: Volvemos a lanzar el error para que `onClickSaveSeason` lo maneje
  }
};

export const getSeasonByDate = async (date) => {
  const query = {
    where: {
      and: [
        {
          initDate: {
            less_than_equal: date
          }
        },
        {
          endDate: {
            greater_than_equal: date
          }
        }
      ]
    },
    sort: 'endDate',
    //depth: 1//para evitar hacer subqueries
  };

  const stringifiedQuery = qs.stringify(
    query,
    { addQueryPrefix: true } //creo que es para añadir "?"
  )
  IS_LOCAL_ENV && console.log("query: ", stringifiedQuery);
  try {
    const { data } = await _axios.get(`/api/seasons${stringifiedQuery}`);
    return data;
  }
  catch (err) {
    IS_LOCAL_ENV && console.error(err);
    throw err;
  }
}

export const getBSDatesByBlockIdByDate = async (blockId, date) => {

  const query = {
    where: {
      and: [
        {
          block: {
            equals: blockId,
          },
        },
        {
          date: {
            greater_than_equal: date //fechas mayores o iguales a la fecha actual
          }
        }
      ],
    },
    sort: 'date',
    limit: 2, //solo 2  
    //depth: 1//para evitar hacer subqueries
  };

  const stringifiedQuery = qs.stringify(
    query,
    { addQueryPrefix: true } //creo que es para añadir "?"
  )

  try {
    const { data } = await _axios.get(`/api/blockSDates/${stringifiedQuery}`);
    return data;
  }
  catch (err) {
    IS_LOCAL_ENV && console.error(err);
    throw err;
  }
}

// export const deleteSeason = async (season) => {
//   try {
//     // Validar que la temporada tiene bloques asociados
//     if (season.blocks && season.blocks.length > 0) {
//       // Iterar sobre los bloques de la temporada
//       for (const block of season.blocks) {
//         // Verificar si el bloque tiene blockSDates y no está vacío
//         if (block.blockSDates && block.blockSDates.length > 0) {
//           const deleteBlockSDatesPromises = block.blockSDates.map((blockSDateId) =>
//             _axios.delete(`/api/blockSDates/${blockSDateId}`) // Eliminar cada blockSDate por su ID
//           );

//           // Esperar a que todas las promesas de eliminación de blockSDates se resuelvan
//           await Promise.all(deleteBlockSDatesPromises);
//           IS_LOCAL_ENV && console.log(`BlockSDates de bloque ${block.id} eliminados exitosamente.`);
//         } else {
//           IS_LOCAL_ENV && console.log(`El bloque ${block.id} no tiene blockSDates o está vacío.`);
//         }

//         // Eliminar el bloque después de procesar sus blockSDates
//         await _axios.delete(`/api/blocks/${block.id}`);
//         IS_LOCAL_ENV && console.log(`Bloque ${block.id} eliminado exitosamente.`);
//       }
//     } else {
//       IS_LOCAL_ENV && console.log("La temporada no tiene bloques asociados.");
//     }

//     // Eliminar la temporada después de eliminar los bloques y sus blockSDates
//     await _axios.delete(`/api/seasons/${season.id}`);
//     IS_LOCAL_ENV && console.log("Temporada eliminada exitosamente.");
//   } catch (err) {
//     IS_LOCAL_ENV && console.error("Error al eliminar la temporada, sus bloques o blockSDates:", err);
//     throw err;
//   }
// };

//delete season with promise all
export const deleteSeason = async (season) => {
  try {
    if (season.blocks && season.blocks.length > 0) {
      // Eliminar primero todos los blockSDates en paralelo
      const deleteBlockSDatesPromises = season.blocks.flatMap((block) => {
        if (block.blockSDates && block.blockSDates.length > 0) {
          return block.blockSDates.map((blockSDateId) =>
            _axios.delete(`/api/blockSDates/${blockSDateId}`)
          );
        }
        return [];
      });

      await Promise.all(deleteBlockSDatesPromises);
      IS_LOCAL_ENV && console.log("Todos los blockSDates eliminados.");

      // Ahora eliminar todos los bloques en paralelo
      const deleteBlocksPromises = season.blocks.map((block) =>
        _axios.delete(`/api/blocks/${block.id}`)
      );

      await Promise.all(deleteBlocksPromises);
      IS_LOCAL_ENV && console.log("Todos los bloques eliminados.");
    } else {
      IS_LOCAL_ENV && console.log("La temporada no tiene bloques asociados.");
    }

    // Finalmente, eliminar la temporada
    const { data } = await _axios.delete(`/api/seasons/${season.id}`);
    IS_LOCAL_ENV && console.log("Temporada eliminada exitosamente.");
    return data;
  } catch (err) {
    IS_LOCAL_ENV &&
      console.error("Error al eliminar la temporada, sus bloques o blockSDates:", err);
    throw err;
  }
};

export const saveSeason = async (season) => {
  //received season with blockSDates changed
  try {
    // Validar que la temporada tiene bloques
    if (!season.blocks || season.blocks.length === 0) {
      IS_LOCAL_ENV && console.warn("La temporada no tiene bloques asociados.");
      return;
    }

    // Actualizar cantidades de fechas programadas en paralelo
    const updatePromises = season.blocks.map((block) =>
      block.blockSDates.map((bsd) => {
        const constumptionsFormatted = bsd.comsumptions.map((consumption) => {
          return { //en el back el formato del field comsumptions(consumptions seria la palabra corregida 🧐) es de tipo array 
            id: consumption.id,
            quantity: parseInt(consumption.quantity),
            supplie: consumption.supplie.id //solo capturo el id. debido a la produndidad de la query, supplie es un objeto con todas las props del supplie
            //podria no necesitarse especificar el id si la profundidad de la query fuera menor, pero en este caso necesitamos la info de las relaciones(subqueries)//
          };
        });
        return _axios.patch(`/api/blockSDates/${bsd.id}`, { comsumptions: constumptionsFormatted });
      }

      )
    );

    // Aplanar el array de promesas antes de pasarlas a Promise.all
    const flatPromises = updatePromises.flat();

    // Esperar a que todas las promesas se resuelvan
    await Promise.all(flatPromises);
    IS_LOCAL_ENV && console.log("Fechas programadas actualizadas exitosamente.");

    // await Promise.all(updatePromises);
    // IS_LOCAL_ENV && console.log("Fechas programadas actualizadas exitosamente.");

    // Cambiar estado de la temporada a "published"
    if (season.status == "pending") await updateSeasonStatus(season.id, "published");
    IS_LOCAL_ENV && console.log(`Temporada ${season.id} actualizada a "published".`);
    return true;
  } catch (err) {
    IS_LOCAL_ENV && console.error("Error al guardar la temporada:", err);
    throw err;
  }
};
